import React, { Component, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { applyDataTable } from '../../custom/dataTable';
import Save from '../../../assets/img/svg/saveIcon.svg';
import Cancel from '../../../assets/img/svg/cancelIcon.svg';
import Delete from '../../../assets/img/svg/delete.svg';
import save from '../../../assets/img/svg/saveIcon.svg';
import cancel from '../../../assets/img/svg/cancelIcon.svg';
import deleteIcon from '../../../assets/img/svg/delete.svg';
import upload from '../../../assets/img/svg/upload.svg';
import desc from '../../../assets/img/svg/desc.svg';
// import Dropzone from "react-dropzone";
import { TextField } from "@material-ui/core"
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import del from '../../../assets/img/svg/Del.svg';
import $ from 'jquery';
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
// import EditOPA_Historylog from '../DailyTasks/OperationPlanningAchievements/EditOPA-Historylog';
import HistoryLog from "./HistoryLog";
import UploadFile from "./UploadFile"
import styles from "../../../assets/jss/customStyle";
import withRouter from "../../custom/withRouter";
import Divider from '@material-ui/core/Divider';
import { addcorrectdocumentinfo } from "../../../actions/CorrectiveActions"
import axios from "axios";
import API from "../../../_helpers/endpointService"

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}




class UploadDocument extends Component {
    constructor(props) {
        super(props)
        this.state = {
            UserRole: "",
            ProjectId: 0,
            isMobile: false,
            value: 0,
        }

    }

    sidebar = () => {
        this.props.navigate("/sidebaryarddocument");
    }

    componentDidMount() {
        const { dispatch } = this.props;
        applyDataTable("staffTable");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.ProjectId = localStorage.getItem("DashId");
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#CorrectiveActions1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#CorrectiveActions").addClass("d-none");
        $("#CorrectiveActions").removeClass("d-block");
        $("#CA .MuiListItemText-primary").removeClass("fw-bolder")
        $("#CAL").removeClass("active-color")
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#CorrectiveActions1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#CorrectiveActions").removeClass("d-none");
        $("#CorrectiveActions").addClass("d-block");
        $("#CA .MuiListItemText-primary").addClass("fw-bolder")
        $("#CAL").addClass("active-color")
    };

    SaveItem = () => {
        let formData = new FormData()
        Array.from(this.props.correctdocs).forEach(async (a) => {
            formData.append("formFiles", a.fdata)
        })
        this.addcorrectdocumentinfo(formData, this.state.ProjectId, this.state.UserRole)
    }

    addcorrectdocumentinfo = (data, id, modify) => {
        let apiUrl = API.CORRECTIVE_ACTIONS + id + '?modify=' + modify
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
           
        })
            .then((response) => {
                this.props.dispatch({ type: "HIDE_CORRECTDEL", data: [] })
                if (response?.status === 200) {
                    this.props.navigate(`/correctiveaction`)
                    this.props.dispatch({ type: "CORRECTIVE_UPLOAD", data: [] });
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "HIDE_CORRECTDEL", data: [] })
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    DeleteItem = () => {
        let tempData = [];
        Array.from(this.props.correctdocs).forEach(async (a) => {
            if (a.check != true) {
                tempData.push(a)
            }
        })
        this.props.dispatch({ type: "CORRECTIVE_UPLOAD", data: tempData })
        window.$("#exampleModal123").modal("hide");
        this.props.dispatch({ type: "HIDE_CORRECTDEL", data: [] })
    }

    SetActive = (str) => {
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
    };

    cancelUpload = () => {
        this.props.dispatch({ type: "CORRECTIVE_UPLOAD", data: [] })
        this.props.dispatch({ type: "HIDE_CORRECTDEL", data: [] })
        this.props.navigate(`/correctiveaction`)
    }

    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-5 w-50 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"CorrectiveActions" + "1"} className='textNaviIcon' onClick={() => this.sidebar()} primary="Corrective Actions" />
                                            <NavigateNextIcon id="CorrectiveActions" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-7 pt-2 mt-5 w-50">
                                    <h4 className="pt-2">Upload Documents</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                {/* <div className="" style={{ backgroundColor: "white",width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '': -95 }}> */}
                {/* <div className="">
                    <List className="text-center  position-fixed" style={{ backgroundColor: "#F6F6F6", width: 240, height: "100vh " }} >
                        {['Documents'].map((text, index) => (
                            <ListItem className="" button key={text} onClick={() => SetActive(text.replaceAll(" ", ""))}>
                                <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                            </ListItem>
                        ))}
                    </List>
                </div> */}
                <div className="ml-auto" style={{ width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <i class="fa fa-arrow-left cursorPointer" onClick={() => { this.props.navigate(`/correctiveaction`) }}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} disabled={this.props.savecorrect.length > 0 ? false : true} onClick={() => { this.SaveItem() }}><img src={Save} style={{ marginTop: '-4px', opacity: this.props.savecorrect.length > 0 ? "" : "0.5" }}></img>&nbsp;Save</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button} pl-3`} onClick={() => { this.props.navigate(`/correctiveaction`) }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button} pl-3`} disabled={this.props.hide.length > 0 ? false : true} onClick={() => { window.$("#exampleModal123").modal("show"); }} ><img src={Delete} style={{ marginTop: '-4px', opacity: this.props.hide.length > 0 ? "" : "0.5" }}></img>&nbsp;Delete</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center cursorPointer" onClick={() => { this.props.navigate(`/correctiveaction`) }}><i className="fa fa-arrow-left cursorPointer"></i></td>
                                    <td className="">
                                        <img src={save} className="cursorPointer" style={{ marginTop: '-4px', opacity: this.props.savecorrect.length > 0 ? "" : "0.5" }}></img>
                                        <button className={`${classes.button} pl-2`} disabled={this.props.savecorrect.length > 0 ? false : true} onClick={() => { this.SaveItem() }}>Save</button> &nbsp;
                                        <img src={cancel} className="cursorPointer" style={{ marginTop: '-4px' }}></img>
                                        <span className="p-2 cursorPointer" onClick={() => { this.cancelUpload() }}>Cancel</span> &nbsp;
                                        <img src={deleteIcon} className="cursorPointer" style={{ marginTop: '-4px', opacity: this.props.hide.length > 0 ? "" : "0.5" }}></img>
                                        <button className={`${classes.button} pl-2`} disabled={this.props.hide.length > 0 ? false : true} onClick={() => { window.$("#exampleModal123").modal("show"); }}>Delete</button>
                                    </td>
                                    {/* <td width="75%"></td> */}
                                </tr>
                            </tbody>
                        </table>}
                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "15px 45px" }}>
                        {this.state.isMobile ? <></> : <h6>Upload Documents</h6>}
                        <div className="row mt-3">
                            <div>
                                <AppBar position="static" color="inherit" className={classes.root}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab label="Details" {...a11yProps(0)} />
                                        <Tab label="History log" {...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={this.state.value} index={0}>
                                    <UploadFile />
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <HistoryLog />
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div>
                        {/* <Dropzone
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50vh",
                        border: " 2px dashed"
                    }}
                    multiple={false}
                    accept="application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    onDrop={(accepted, rejected) => onDrop(accepted, rejected)}
                >
                    {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
                        if (isDragReject) return "Please submit a valid file";
                        return render;
                    }}
                </Dropzone> */}
                        {/* </div> */}
                        {/* <div style={{ margin: "15px 45px" }}>
                        <h6>Operation Planning & Acheivement </h6>

                    </div> */}


                    </div>
                </div>
                <div class="modal fade pt-5 mt-5" id="Save" tabindex="-1" role="dialog" aria-labelledby="exampleModal12Label" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body bp-0">
                                <div className="row">
                                    <div className="text-center d-flex pt-3">
                                        <label class="fw-bold">Comments  </label>
                                        <lable className="ml-1">
                                        </lable>
                                        <TextField
                                            multiline
                                            rows={3}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                            InputProps={{
                                                className: "border-radius"
                                            }}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.SaveItem()} ><span className="" >Save</span></button>
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal" onClick={() => { window.$("#Save").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="exampleModal123" tabindex="-1" role="dialog" aria-labelledby="exampleModal12Label" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => this.DeleteItem()} style={{ backgroundColor: "#00838F", border: "none" }} ><span className="" >Delete</span></button>
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" onClick={() => { window.$("#exampleModal123").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        correctdocs: state.CorrectiveActionsReducer.correctdocs || [],
        hide: state.CorrectiveActionsReducer.hidecorrect || [],
        savecorrect: state.CorrectiveActionsReducer.savecorrect || [],
        // projectList: state.projectReducer.projectList || [],
        // projectNames: state.projectReducer.projectNames || [],
    };
}

UploadDocument.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UploadDocument))
);
